import { deleteRequest, patchRequest, postRequest } from 'services/requests';

const services = {
    createSubmission: (body) => postRequest(`/submissions`, body),
    updateSubmission: (id, body) => patchRequest(`/submissions/${id}`, body),
    deleteSubmission: (id) => deleteRequest(`/submissions/${id}`),
};

export default services;
